<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <app-autocomplete
                            placeholder="Cliente"
                            :items="clients"
                            v-model="selectClient"
                            
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="6" lg="4">
                        <app-form-select-input :placeholder="!!selectClient?'Estructura': 'Estructura (seleccione cliente)'" :options="accessPoints" v-model="filters.structure"></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <app-autocomplete
                            placeholder="Creador"
                            :items="authors"
                            v-model="selectUser"
                        /> 
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="from" placeholder="Desde" v-model="filters.from" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="6" md="4" lg="2">
                        <app-date-time-picker id="to" placeholder="Hasta" v-model="filters.to" :with-time="false"></app-date-time-picker>
                    </b-col>
                    <b-col cols="12" md="2" lg="1" offset-lg="10">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="2" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import structuresRepository from '../../../../repositories/structures.repository.js';
import safetyRecommendationsRepository from '../../../../repositories/safetyRecommendations.repository';
import Autocomplete from '../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import DateTimePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue';
export default {
    components: {
        appAutocomplete: Autocomplete,
        appDateTimePicker: DateTimePicker
    },
    data(){
        return {
            filters: {
                structure: '',
                user: '',
                client: '',
                from: '',
                to: ''
            },
            selectUser: '',
            selectClient: '',
            accessPoints: [],
            authors: []
        }
    },
    computed: {
            ...mapGetters(['clients'])
        },
    watch:{
        selectUser(val){
            if(!val){
                this.filters.user= '';
                this.selectUser = '';
            }else{
                this.filters.user = val.id;
            }
        },
        selectClient(val){
            if(!val){
                this.filters.client= '';
                this.selectClient = '';
            }else{
                this.filters.client = val.id;
                this.loadAccessPoints(val.id);
            }
        }
    },
    methods: {
        loadAccessPoints(){
            const sr = {...structuresRepository};
            sr.accessPointsByClient(this.filters.client)
            .then(data => this.accessPoints = data)
            .catch(error => toastr.error('Error al cargar los puntos de acceso en recomendaciones de seguridad'));
        },
        loadAuthorsRecommendations() {
            const srr = {...safetyRecommendationsRepository};
            srr.loadSafetyRecommendationsAuthors()
            .then(data => this.authors = data)
            .catch(error => toastr.error( "Ocurrió un error al cargar los autores"));
        },
        clearFilters(){
            this.selectUser = '';
            this.selectClient = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created(){
        this.loadAuthorsRecommendations();
    }
}
</script>

